import React from 'react';
import WorkspacePage from '../components/layout/WorkspacePage';
import './StarterMode.css';

const STARTER_CARDS = [
  {
    icon: 'G',
    title: 'Set your first goal',
    body: 'Create one operating target so this location has a clear performance signal.',
    action: 'Open Goals',
    path: '/goals'
  },
  {
    icon: 'R',
    title: 'Import roster',
    body: 'Add leaders and team members before assigning ownership or recording actuals.',
    action: 'Open Roster',
    path: '/managers'
  },
  {
    icon: 'A',
    title: 'Connect actuals',
    body: 'Once goals and roster are in place, enter the first actuals to activate reporting.',
    action: 'Open Actuals',
    path: '/actuals'
  }
];

function StarterMode({ locationLabel = 'Selected Location', onNavigate = () => {} }) {
  // Sprint 3B.8: StarterMode is a pure onboarding/instructional view —
  // 3 setup cards above a short orientation paragraph. width="narrative"
  // keeps the cards from ballooning past readable widths on ultrawide
  // displays. The bespoke .starter-mode-hero block is removed; its
  // eyebrow / title / subtitle flow into WorkspacePage's standard
  // slots. The inner .starter-mode-page wrapper survives so the
  // existing grid layout keeps applying without a stylesheet rewrite.
  return (
    <WorkspacePage
      data-workspace-id="starter-mode"
      width="narrative"
      eyebrow="Location Starter Mode"
      title={`${locationLabel} is ready for setup`}
      subtitle="This location has no goals and no roster yet. Start with the three setup actions below to make the workspace operational."
    >
      <main className="starter-mode-page" aria-labelledby="starter-mode-title">
        <section className="starter-mode-grid" aria-label="Starter setup actions">
          {STARTER_CARDS.map(card => (
            <article className="starter-mode-card" key={card.title}>
              <span className="starter-mode-card-icon" aria-hidden>{card.icon}</span>
              <h2>{card.title}</h2>
              <p>{card.body}</p>
              <button type="button" onClick={() => onNavigate(card.path)}>
                {card.action}
              </button>
            </article>
          ))}
        </section>
      </main>
    </WorkspacePage>
  );
}

export default StarterMode;
